export const CustomDate = (convertedDate) => {
    let date;
    let month;
    let year;
    let newDate;
    let dmyDate;
    // convertedDate ? typeof (convertedDate) === "string" ? convertedDate : dmyDate : ""
    const createdDate = convertedDate && new Date(convertedDate);
    if (typeof (convertedDate) === "string") {
        let myDate = convertedDate.split("/");
        let newDate = new Date(myDate[2], myDate[1] - 1, myDate[0]);
        let dt = new Date(newDate);
        date = dt && dt?.getDate()
        month = dt && dt?.getMonth() + 1
        year = dt && dt?.getFullYear()
        newDate = year + "/" + (month > 9 ? month : "0" + month) + "/" + (date > 9 ? date : "0" + date)
        newDate = newDate === "NaN/0NaN/0NaN" ? "-" : newDate;
        dmyDate = year + "/" + (month > 9 ? month : "0" + month) + "/" + (date > 9 ? date : "0" + date)
        dmyDate = dmyDate === "NaN/0NaN/0NaN" ? "-" : dmyDate;
        // dmyDate = convertedDate
    } else {
        const temp = new Date(convertedDate)
        date = temp && temp?.getDate()
        month = temp && temp?.getMonth() + 1
        year = temp && temp?.getFullYear()
        newDate = year + "/" + (month > 9 ? month : "0" + month) + "/" + (date > 9 ? date : "0" + date)
        newDate = newDate === "Invalid date" ? "-" : newDate;
        dmyDate = year + "/" + (month > 9 ? month : "0" + month) + "/" + (date > 9 ? date : "0" + date)
        dmyDate = dmyDate === "Invalid date" ? "-" : dmyDate;
    }
    return { newDate, dmyDate }

}
export const CustomAPIDate = (convertedDate) => {

    // convertedDate ? typeof (convertedDate) === "string" ? convertedDate : dmyDate : ""
    const createdDate = convertedDate && new Date(convertedDate);

    const date = createdDate && createdDate?.getDate()
    const month = createdDate && createdDate?.getMonth() + 1
    const year = createdDate && createdDate?.getFullYear()
    let newDate = year + "/" + (month > 9 ? month : "0" + month) + "/" + (date > 9 ? date : "0" + date)
    newDate = newDate === "Invalid date" ? "-" : newDate;
    let dmyDate = (date > 9 ? date : "0" + date) + "/" + (month > 9 ? month : "0" + month) + "/" + year
    dmyDate = dmyDate === "Invalid date" ? "-" : dmyDate;
    return { newDate, dmyDate, month: (month > 9 ? month : "0" + month), date: (date > 9 ? date : "0" + date) }
}

export const StringToDate = (strDate) => {
    var myDate = strDate.split("/");
    var newDate = new Date(myDate[2], myDate[1] - 1, myDate[0]);
    let dt = new Date(newDate);
    dt = dt === "Invalid date" ? "-" : dt;
    return { dt };
}

export const dashedDate = (date) => {
    let newDate = null;
    if (date) {
        const dateValue = date.split("/");
        newDate = dateValue?.[2] + "-" + dateValue?.[1] + "-" + dateValue?.[0];
    }
    return { newDate };
}
